import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-editor-section-toolbar',
  templateUrl: './fb-editor-section-toolbar.component.html',
  styleUrls: ['./fb-editor-section-toolbar.component.css']
})
export class FbCoreEditorSectionToolbarComponent implements OnInit {
    @Input()
    status: string;

    constructor() { }

    ngOnInit(): void {
    }
}
